import React, { useEffect, useState } from "react";
import { Row, Input, Select, Form, Col, Spin, Modal } from "antd";
import { getRequest, putRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { toast } from "react-toastify";
import Preview from "../Preview/preview";
import { EditOutlined, SaveOutlined } from "@ant-design/icons";
import "../table/viewMicrosite.scss";
import { inputFieldCharLimit } from "../../config";

export default function ViewMicrositeDetails({
  ClearRow,
  orgId,
  HideViewMicrositeHandler,
  showTagsHandler,
  closeModal,
}) {
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [oneOrgData, setOneOrgData] = useState(null);
  const [, setMicrosites] = useState([]);
  const [microsite, setMicrosite] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingType, setIsEditingType] = useState(false);
  const [editName, setEditName] = useState(null);
  const [editType, setEditType] = useState(null);
  const [, setPartnerData] = useState({});
  const [OrganisationTypes, setOrganisationTypes] = useState([]);

  const getPartnerDetailsData = () => {
    setLoading(true);
    getRequest(userServiceApi.partnerDetails())
      .then((response) => {
        if (response && response.data) {
          // if (!response.data.mediaLink) {
          //   setIsTabDisable(true);
          // }
          setPartnerData({ ...response.data });
          setOrganisationTypes(response.data.organizationTypes);
          // console.log("atAPI", response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.error);
      });
  };

  useEffect(() => {
    getPartnerDetailsData();
  }, []);

  const handleEditClickName = () => {
    setIsEditingName(true);
  };

  const handleSaveClickName = async () => {
    try {
      // console.log("edited name before api call", editName)
      await updateOneOrganisationData();
      // console.log("came out of api")
      setIsEditingName(false);
      closeModal();
      // console.log("edit namemeee", isEditingName)
    } catch (error) {
      console.error("Failed to update data.", error);
      toast.error("Please change organisation name before saving.");
    }
  };

  const handleEditClickType = () => {
    setIsEditingType(true);
    // toast("Organisation name also needs to be changes");
  };

  // const nameToId = (name) => {
  //   const foundType = OrganisationTypes.find((type) => type.name === name);
  //   return foundType ? foundType.id : null;
  // };

  const handleSaveClickType = async () => {
    try {
      // console.log("edited type", editType)
      await updateOneOrganisationData();
      setIsEditingType(false);
      closeModal();
    } catch (error) {
      console.error("Failed to update data.", error);
      toast.error("Failed to update data. Please try again.");
    }
  };

  //   console.log("type edited", editedType);
  //   console.log("name edited", editedName);

  const updateOneOrganisationData = async () => {
    try {
      const name = editName;
      // const formatedName = name?.replace(/ /g, "-");
      // console.log("editedname in api call", formatedName)
      const type = editType;
      // console.log("editedtype in api call", type);
      const response = await putRequest(
        userServiceApi.updateOneOrganisationData(orgId, name, type)
      );
      // console.log("response")
      if (response) {
        toast.success("Successfully updated data.");
      } else {
        throw new Error("Failed to update data. No response data.");
      }
    } catch (error) {
      throw error;
    }
  };

  const getOneOrganizationData = async () => {
    try {
      const response = await getRequest(
        userServiceApi.getOneOrganization(orgId)
      );
      // console.log(response, "ressponse");

      if (response.data) {
        setOneOrgData(response.data);
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  const getMicrositesData = async () => {
    try {
      setLoading(true);
      const response = await getRequest(
        userServiceApi.getMicrositesByOrganization(orgId)
      );

      if (response.data) {
        setMicrosites(response.data);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error.error);
    }
  };

  useEffect(() => {
    getOneOrganizationData();
    getMicrositesData();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  const RemoveMicrosite = () => {
    setMicrosite(null);
  };

  const handleCancel = () => {
    closeModal();
  };
  // console.log(oneOrgData);
  if (loading || loader) {
    // return (
    //   <div className="data-loader">
    //     <Spin className="spin" tip="Loading" size="large" />
    //   </div>
    // );
  }
  // else {
  return (
    <>
      <Modal
        open={true}
        onCancel={handleCancel}
        // closeIcon={<img className="closeIcon" src={closeIcon} />}
        footer={null}
        className="viewMicrositeModal"
      >
        {loading || loader ? (
          <div className="approve-container">
            <div className="data-loader">
              <Spin className="spin" tip="Loading" size="large" />
            </div>
          </div>
        ) : (
          <div className="approve-container">
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent logo-container" span={24}>
                <div className="img-container">
                  <img
                    src={oneOrgData?.mediaLink}
                    alt={""}
                    className="preview-image"
                  />
                </div>
                {/* <div className="btn-container">
                  {microsites.map((microsite) => {
                    return (
                      <div className="inputBody-btns">
                        <Button
                          className="view-btn"
                          type="button"
                          onClick={() => ShowSubsectionhandler(microsite.id)}
                        >
                          View Site
                        </Button>
                      </div>
                    );
                  })}
                </div> */}
              </Col>
            </Row>

            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Name
              </Col>
              <Col className="gutter-row tabContent" span={9}>
                {isEditingName ? (
                  <Form.Item>
                    <Input
                      defaultValue={oneOrgData?.name}
                      onChange={(e) => setEditName(e.target.value)}
                      maxLength={inputFieldCharLimit}
                    />
                  </Form.Item>
                ) : (
                  <div> {editName || oneOrgData?.name} </div>
                )}
              </Col>
              <Col className="gutter-row tabContent" span={2}>
                {isEditingName ? (
                  <SaveOutlined onClick={handleSaveClickName} />
                ) : (
                  <EditOutlined onClick={handleEditClickName} />
                )}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Type
              </Col>
              <Col className="gutter-row tabContent-body" span={9}>
                {isEditingType ? (
                  <Form.Item>
                    <Select
                      defaultValue={
                        oneOrgData?.type?.length > 0
                          ? oneOrgData?.type
                          : ""
                      }
                      onChange={(value) => setEditType(value)}
                    >
                      {/* Assuming OrganiationTypes is an array of objects with id and name properties */}
                      {OrganisationTypes?.map((OrganisationType) => (
                        <Select.Option
                          key={OrganisationType}
                          value={OrganisationType}
                        >
                          {OrganisationType}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : (
                  <div>
                    {editType ||
                      (oneOrgData?.type?.length > 0 ? oneOrgData?.type : "")}
                  </div>
                )}
              </Col>
              <Col className="gutter-row tabContent" span={2}>
                {isEditingType ? (
                  <SaveOutlined onClick={handleSaveClickType} />
                ) : (
                  <EditOutlined onClick={handleEditClickType} />
                )}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Size
              </Col>
              <Col className="gutter-row tabContent-body" span={12}>
                {oneOrgData?.size === "MICRO"
                  ? "Micro"
                  : oneOrgData?.size === "SMALL"
                    ? "Small"
                    : oneOrgData?.size === "MEDIUM"
                      ? "Medium"
                      : oneOrgData?.size === "LARGE"
                        ? "Large"
                        : ""}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Categories
              </Col>
              <Col className="gutter-row tabContent-body" span={12}>
                {oneOrgData?.sectorsOutputs[0]?.sectorOutput.name}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Sub categories
              </Col>
              <Col className="gutter-row tabContent-body" span={12}>
                {oneOrgData?.sectorsOutputs[0]?.subSectorOutput.name}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Website
              </Col>
              <Col className="gutter-row tabContent-body" span={12}>
                {oneOrgData?.websiteLink}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Email
              </Col>
              <Col className="gutter-row tabContent-body" span={12}>
                {oneOrgData?.email}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Phone
              </Col>
              <Col className="gutter-row tabContent-body" span={12}>
                {oneOrgData?.phone}
              </Col>
            </Row>
            <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row tabContent" span={5}></Col>
              <Col className="gutter-row tabContent" span={5}>
                Address
              </Col>
              <Col className="gutter-row tabContent-body" span={12}>
                {oneOrgData?.addressOutputs.map((address) => {
                  return address.street;
                })}
              </Col>
            </Row>
            {/* <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ justifyContent: "center", marginTop: "5%" }}>
              <Col className="gutter-row tabContent-body" span={26}>
                <div className="btn-container">
                  {microsites.map((microsite) => {
                    return (
                      <div className="inputBody-btns">
                        <Button
                          className="view-btn"
                          type="button"
                          onClick={() => ShowSubsectionhandler(microsite.id)}
                        >
                          View Site
                        </Button>
                      </div>
                    );
                  })}
                </div>
              </Col>
            </Row> */}
          </div>
        )}

        {microsite ? (
          <Preview micrositeId={microsite} RemoveMicrosite={RemoveMicrosite} />
        ) : (
          <></>
        )}
      </Modal>
    </>
  );
}

// }
